/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DELETE USER MODAL
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme =>({
    deleteuser: {
        extend: theme.modal.form,
        maxWidth: pxToEm(432),
        '& .name-deleteuser':{
            '& .bodycopy':{
                marginTop:pxToEm(72),
                textAlign: 'center'
            }
        },
        '& .name-ctas':{
            marginTop:pxToEm(72)
        }
    }
})